module.exports = __webpack_public_path__ + "static/media/RI-D4-11.1-084.308c1b96.webp";